module.exports = __webpack_public_path__ + "static/media/BARefresh.b68e5f1c.svg";